
































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import { mapGetters } from "vuex";
import _ from "lodash";
import { User, Privileges } from "@/types";

axios.defaults.baseURL = process.env.BASE_URL;


interface UserF {
    id: string | null;
    company: string | null;
    privileges: Privileges | null;
    resume: boolean | null;
}

@Component({
    components: {},
    computed: mapGetters(["getUser"])
})

export default class SessionProjectEvaluation extends Vue {
    currentProject: any = { name: '', id: '' };
    currentSession: any = { name: '', id: '', test: '', date: '', projet: '' };
    duplicateSession: any = { name: '', id: '', test: '', date: '', projet: '' };
    allProjects: any[] = [];
    allSessions: any[] = [];
    allUsers: any[] = [];
    repondantSessions: any[] = [];
    getUser: any;
    filtredUser: any;
    private q_description: any = {
        null: "Aucun Test",
        "S7": "S7",
        "P2T": "P2T",
        "DeSI-ACTIV": "DeSI-Métiers",
        "Evaluation Neuroscience": "Evaluation Neuroscience"
    };


    get projectsOpts() {
        return [{ value: null, text: "Aucun" }].concat(
            (!this.allProjects) ? [] : _.sortBy(_.uniq(this.allProjects.map(e => e.name).filter(e => e))
                .map(e => { return { value: e, text: e } })
                , [e => e.text]))
    }

    get usersOpts() {
        return [{ value: null, text: "Veuillez choisir un utilisateur" }].concat(
            (!this.allUsers) ? [] : _.sortBy(_.uniq(this.allUsers.map(e => e._id).filter(e => e))
                .map(e => { return { value: e, text: e } })
                , [e => e.text]))
    }
    onUserChange() {
        if (this.filtredUser != null) {
            axios.get('/api/sessionByUser', {
                params: {
                    user: this.filtredUser
                }
            })
                .then(ans => {
                    this.allSessions = ans.data;
                    this.allSessions.forEach(session => {
                        session.date = this.formatDate(session.date); // Mise à jour du champ date
                    });
                })
        } else {
            axios.get('/api/session')
                .then(ans => {
                    this.allSessions = ans.data;
                    this.allSessions.forEach(session => {
                        session.date = this.formatDate(session.date); // Mise à jour du champ date
                    });
                })
        }
    }

    private stateOptions: any = {
        "Ouverte": "Ouverte",
        "Fermé": "Fermé"
    };

    get creditTypesOptions() {
        return Object.entries(this.q_description).map(([key, value]) => ({
            value: key,
            text: value,
        }));
    }

    get getstateOptions() {
        return Object.entries(this.stateOptions).map(([key, value]) => ({
            value: key,
            text: value,
        }));
    }

    userFilter: UserF = {
        id: null,
        privileges: null,
        company: null,
        resume: null
    };

    handleAddProject() {
        this.$bvModal.show('modal-project');
    }
    handleAddSession() {
        this.$bvModal.show('modal-session');
    }
    formatDate(dateStr) {
        const date = new Date(dateStr);
        return date.toISOString().slice(0, 10); // YYYY-MM-DD
    }
    addProject() {
        if (this.currentProject.name == '') {
            this.$toast.error('Le nom du projet est obligatoire')
        } else {
            axios
                .post('/api/project', {
                    id: this.currentProject.id,
                    name: this.currentProject.name,
                    projet: this.currentProject.projet,
                    created_by: this.getUser.id
                })
                .then(ans => {
                    this.fetch_Items();
                    this.currentProject = { name: '', id: '', prjet: '' };
                    this.$toast.success(ans.data);
                    this.$bvModal.hide('modal-project');
                }).catch(err => {
                    this.currentProject.name = '';
                    this.$toast.error(err.response.data)
                });

        }

    }
    removeProject(p) {
        axios.delete('/api/project', {
            params: {
                id: p.id
            }
        })
            .then(ans => {
                this.$toast.success("projet supprimé avec succés !");
                this.fetch_Items();
            })
            .catch(err => {
                this.$toast.error('Une erreur est survenue');
            });
    }
    updateProject(p) {
        this.currentProject = p;
        this.$bvModal.show('modal-project');
    }
    closeRepondantSession() {
        this.$bvModal.hide('repondant-session');
    }

    addSession() {
        if (this.currentSession.name == '' || this.currentSession.date == '' || this.currentSession.projet == '' || this.currentSession.test == '') {
            this.$toast.error('Tous les champs sont obligatoire')
        } else {
            axios
                .post('/api/session', {
                    id: this.currentSession.id,
                    name: this.currentSession.name,
                    date: this.currentSession.date,
                    projet: this.currentSession.projet,
                    test: this.currentSession.test,
                    created_by: this.getUser.id
                })
                .then(ans => {
                    this.fetch_Items();
                    this.currentSession = { name: '', id: '', test: '', date: '', projet: '' };
                    this.$toast.success(ans.data);
                    this.$bvModal.hide('modal-session');
                }).catch(err => {
                    this.$toast.error(err.response.data)
                    this.currentSession.name = '';
                });

        }
    }
    duplicateSessionAdd() {
        axios
            .post('/api/session', {
                id: this.duplicateSession.id,
                name: this.duplicateSession.name,
                date: this.duplicateSession.date,
                projet: this.currentSession.projet,
                test: this.duplicateSession.test,
                created_by: this.getUser.id
            })
            .then(ans => {
                axios.post('/api/updateSessions', {
                    old_session: this.currentSession.name,
                    new_session: this.duplicateSession.name
                })
                    .catch(error => {
                        this.$toast.error("Erreur lors de la mise à jour des sessions");
                    });
                this.fetch_Items();
                this.duplicateSession = { name: '', id: '', test: '', date: '', projet: '' };
                this.currentSession = { name: '', id: '', test: '', date: '', projet: '' };
                this.$toast.success(ans.data);
            }).catch(err => {
                this.$toast.error('Une erreur est survenue')
            });
        this.$bvModal.hide('modal-session-duplicate');
    }

    removeSession(p) {
        axios.delete('/api/session', {
            params: {
                id: p.id
            }
        })
            .then(ans => {
                this.$toast.success("session supprimé avec succés !");
                this.fetch_Items();
            })
            .catch(err => {
                this.$toast.error('Une erreur est survenue');
            });
    }
    removeUsersSession(id) {
        axios.delete('/api/clearSession', {
            params: {
                id: id
            }
        })
            .then(ans => {
                this.$toast.success("session supprimé avec succés !");
                axios.get('/api/sessionUsers', {
                    params: {
                        session: this.currentSession.name
                    }
                })
                    .then(ans => {
                        this.repondantSessions = ans.data;
                    })
            })
            .catch(err => {
                this.$toast.error('Une erreur est survenue');
            });



    }

    repondantSession(session) {
        this.currentSession = session
        axios.get('/api/sessionUsers', {
            params: {
                session: session.name
            }
        })
            .then(ans => {
                this.repondantSessions = ans.data;
            })
        this.$bvModal.show('repondant-session');
    }

    updateSession(p) {
        this.currentSession = p;
        this.$bvModal.show('modal-session');
    }

    duplicateSessionShow(p) {
        this.currentSession = p;
        this.$bvModal.show('modal-session-duplicate');
    }


    fetch_Items() {
        console.log(this.getUser.admin)
        if (this.getUser.admin) {
            axios.get('/api/project')
                .then(ans => {
                    this.allProjects = ans.data;
                })
            axios.get('/api/session')
                .then(ans => {
                    this.allSessions = ans.data;
                    this.allSessions.forEach(session => {
                        session.date = this.formatDate(session.date); // Mise à jour du champ date
                    });
                })
            axios.get('/api/usersAdminClient')
                .then(ans => {
                    this.allUsers = ans.data;
                });
        } else {
            axios.get('/api/project', {
                params: {
                    created_by: this.getUser.id
                }
            })
                .then(ans => {
                    this.allProjects = ans.data;
                })
            axios.get('/api/session', {
                params: {
                    created_by: this.getUser.id
                }
            })
                .then(ans => {
                    this.allSessions = ans.data;
                    this.allSessions.forEach(session => {
                        session.date = this.formatDate(session.date); // Mise à jour du champ date
                    });
                })
        }

    }

    mounted() {
        this.fetch_Items();
    }

}
